module.exports = __webpack_public_path__ + "static/media/kicksfinder-about-banner.6c7df0f0.png";